<script setup lang="ts">
import { useSlots } from 'vue'
import { useRoute } from 'vue-router'

import { PAGE_NAME_MAPPING } from './Navigation.helpers'

import LogoIcon from '@/assets/icons/metapic-logo-white.svg?component'
import NotificationCenter from '@/components/NotificationCenter/NotificationCenter.vue'
import { config } from '@/lib/helpers'
import { BoxComponent, FlexComponent, TypographyComponent } from '@/ui-library'

defineProps<{ title?: string }>()
const slots = useSlots()
const route = useRoute()
</script>
<template>
  <FlexComponent justify="space-between" align="center" class="header">
    <FlexComponent align="center">
      <BoxComponent :pt="16" :pr="8" :pl="8" :mr="40">
        <a :href="config.legacyAdminAppUrl">
          <el-icon :size="48">
            <LogoIcon />
          </el-icon>
        </a>
      </BoxComponent>

      <FlexComponent align="center" :gap="8">
        <slot v-if="slots.backButton" name="backButton" />
        <TypographyComponent variant="headline-medium" color="var(--inverted)">
          {{ title || PAGE_NAME_MAPPING[route.name as string] }}
        </TypographyComponent>
      </FlexComponent>
    </FlexComponent>
    <FlexComponent>
      <slot />
      <BoxComponent :pl="8">
        <NotificationCenter />
      </BoxComponent>
    </FlexComponent>
  </FlexComponent>
</template>
<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: var(--z-index-max);

  height: 72px;
  padding-left: 8px;
  padding-right: 24px;

  background: var(--primary);
  color: var(--inverted);
}
</style>
